<h3 class="form-modal__title">{{title}}</h3>
<a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal" aria-label="Close">
    <img alt="Close" src="./assets/img/icons-svg/close-icon.svg">
</a>
<div class="form-modal__body"></div>
<div class="form-modal__actions">
    <button (click)="dialogRef.close()" class="app-c-btn app-c-btn--primary app-c-btn--curve">Ok</button>
</div>
